import { useTheme } from "@emotion/react";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faCircleExclamation } from "@fortawesome/pro-light-svg-icons";
import Box from "@ternary/api-lib/ui-lib/components/Box";
import Flex from "@ternary/api-lib/ui-lib/components/Flex";
import Icon from "@ternary/api-lib/ui-lib/components/Icon";
import Text from "@ternary/api-lib/ui-lib/components/Text";
import React from "react";

type InlineAlertProps = {
  icon?: IconDefinition;
  message: string | JSX.Element;
};

// TODO: Make this component more flexible, configurable and reusable when Design System is in place
function InlineAlert({
  icon = faCircleExclamation,
  message,
}: InlineAlertProps): JSX.Element {
  const theme = useTheme();

  // TODO: Use theme colors when Design System is in place
  const backgroundColor = "#FFFAEB";
  const iconColor = "#DC6803";
  const textColor = "#535862";

  return (
    <Box
      backgroundColor={backgroundColor}
      borderRadius={theme.borderRadius_4}
      padding={theme.space_md}
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        flex={1}
        gap={theme.space_sm}
      >
        <Icon icon={icon} color={iconColor} />
        <Text color={`${textColor} !important`}>{message}</Text>
      </Flex>
    </Box>
  );
}

export default InlineAlert;
